import Link from "next/link";
import { Flex, FlexProps } from "../../atoms";
import { styled } from "utils";
import { useRouter } from "next/router";
import { isActivePath, Paths } from "config/paths";

const StyledLink = styled("a", {
  fontSize: "$4",
  fontWeight: "$bold",
  variants: { active: { true: { color: "$primary" } } },
});

type NavListProps = React.HTMLAttributes<HTMLUListElement> & FlexProps;

const NavigationList: React.FC<NavListProps> = ({
  direction = "row",
  ...props
}) => {
  const { pathname } = useRouter();
  const linkProps = (path: string) => ({
    active: isActivePath(pathname, path),
    css: { fontWeight: direction === "column" ? "$extrabold" : undefined },
  });
  return (
    // @ts-expect-error
    <Flex
      as="ul"
      direction={direction}
      gap="5"
      css={{ marginRight: "$6", alignItems: "center" }}
      {...props}
    >
      <li>
        <Link href={Paths.root} passHref>
          <StyledLink {...linkProps(Paths.root)}>Home</StyledLink>
        </Link>
      </li>
      <li>
        <Link href={Paths.about} passHref>
          <StyledLink {...linkProps(Paths.about)}>Sobre nosotros</StyledLink>
        </Link>
      </li>
      <li>
        <Link href={Paths.properties} passHref>
          <StyledLink {...linkProps(Paths.properties)}>Propiedades</StyledLink>
        </Link>
      </li>
      <li>
        <Link href={Paths.contact} passHref>
          <StyledLink {...linkProps(Paths.contact)}>Contacto</StyledLink>
        </Link>
      </li>
    </Flex>
  );
};

export { NavigationList };
